

enum StpType {
  GROSS_PAYMENTS
};


export default StpType;
